import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/Statistical'

const Statistical = {
  GetHrCount(data) {
    return $http({
      method: 'get',
      url: `${BASEURL}/GetHrCount`,
      data
    })
  }

}

export default Statistical
